import { useAuth } from "../../contexts/auth/Context";
import { useCurrentGym } from "../gym/useCurrentGym";
import { decodeUserInfo, isManager } from "../../utils/user";

export const useDashboardData = () => {
  const { token } = useAuth();
  const { role, gymName, email } = decodeUserInfo(token);
  const isManagerRole = isManager(role);

  const { data: gym, isLoading: isLoadingGym } = useCurrentGym();
  const modulesSettings = gym?.modulesSettings ?? null;

  return {
    role,
    gymName,
    email,
    isManagerRole,
    modulesSettings,
    isLoadingGym,
  };
};
